import { extendTheme } from "@chakra-ui/react";

import { fonts } from "./fonts";
import { colours } from "./colours";

import { alertTheme } from "./components/alert";
import { buttonTheme } from "./components/button";
import { checkboxTheme } from "./components/checkbox";
import { inputTheme } from "./components/input";
import { linkTheme } from "./components/link";
import { menuTheme } from "./components/menu";
import { modalTheme } from "./components/modal";
import { spinnerTheme } from "./components/spinner";
import { tableTheme } from "./components/table";
import { tabsTheme } from "./components/tabs";
import { tagTheme } from "./components/tag";
import { textAreaTheme } from "./components/textArea";
import { tooltipTheme } from "./components/tooltip";

const overrides = {
	fonts: fonts,
	colors: colours,
	components: {
		Alert: alertTheme,
		Button: buttonTheme,
		Checkbox: checkboxTheme,
		Input: inputTheme,
		Link: linkTheme,
		Menu: menuTheme,
		Modal: modalTheme,
		Spinner: spinnerTheme,
		Table: tableTheme,
		Tabs: tabsTheme,
		Tag: tagTheme,
		Textarea: textAreaTheme,
		Tooltip: tooltipTheme,
	},
};

// https://v2.chakra-ui.com/docs/styled-system/customize-theme#using-theme-extensions
export const theme = extendTheme(overrides);
